var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1967 14.3001C15.3672 14.3001 17.9375 11.211 17.9375 7.40048C17.9375 3.58992 15.3672 0.500854 12.1967 0.500854C9.02607 0.500854 6.45581 3.58992 6.45581 7.40048C6.45581 11.211 9.02607 14.3001 12.1967 14.3001Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4488 20.1646C22.2525 17.9423 20.2954 16.2272 17.9374 15.3346C17.6038 15.2093 17.2479 15.1548 16.8921 15.1745C16.5364 15.1943 16.1886 15.2879 15.8709 15.4495C14.7645 16.1264 13.4931 16.4845 12.1967 16.4845C10.9002 16.4845 9.6288 16.1264 8.5224 15.4495C8.19649 15.3071 7.84473 15.2335 7.48915 15.2335C7.13356 15.2335 6.7818 15.3071 6.45589 15.4495C4.09787 16.3421 2.14081 18.0571 0.944509 20.2794C0.14098 21.7741 1.40396 23.4992 3.12571 23.4992H21.2669C21.667 23.5138 22.0641 23.4248 22.4198 23.2407C22.7754 23.0566 23.0776 22.7837 23.2971 22.4483C23.5165 22.1129 23.6458 21.7265 23.6724 21.3264C23.6989 20.9263 23.6219 20.5261 23.4488 20.1646Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.5445286d.svg";
export { ForwardRef as ReactComponent };